import { JournalPageState, JournalState } from "@/interfaces/journal.interface";
import { atom, RecoilState, selectorFamily } from "recoil";

export const defaultJournalState: JournalState = {
  term: "",
  journals: [],
  acs: [],
  displayHelper: {
    count: 0,
    error: false,
    page: 1,
    size: 10,
  },
};

export const journalState: RecoilState<JournalState> = atom({
  key: "journal",
  default: defaultJournalState,
});

type JournalMergeField = "displayHelper";

export const journalMergeField = selectorFamily<any, JournalMergeField>({
  key: "journalMergeField",
  get: (field: JournalMergeField) => ({ get }) => get(journalState)[field],
  set: (field: JournalMergeField) => ({ set }, newValue) =>
    set(journalState, (prevState) => {
      // @ts-ignore
      const { __typename, ...others } = newValue;
      return {
        ...prevState,
        [field]: { ...prevState[field], ...others },
      };
    }),
});

export const journalReplaceField = selectorFamily<any, keyof JournalState>({
  key: "journalReplaceField",
  get: (field: keyof JournalState) => ({ get }) => get(journalState)[field],
  set: (field: keyof JournalState) => (
    { set },
    newValue: JournalState[typeof field]
  ) => set(journalState, (prevState) => ({ ...prevState, [field]: newValue })),
});

export const journalPageState: RecoilState<JournalPageState> = atom({
  key: "journalPage",
  default: {
    activateKey: 0,
  },
});

export const journalPageReplaceField = selectorFamily<
  any,
  keyof JournalPageState
>({
  key: "journalPageReplaceField",
  get: (field: keyof JournalPageState) => ({ get }) =>
    get(journalPageState)[field],
  set: (field: keyof JournalPageState) => (
    { set },
    newValue: JournalPageState[typeof field]
  ) =>
    set(journalPageState, (prevState) => ({ ...prevState, [field]: newValue })),
});
